
//bottom layer template
export const getBottomLayerTmpl = (type, title, sub, addButton, addButtonText, plusboxButton, plusboxButtonText) => `
  <div class="popup-dialog ui-popup ui-bottom" data-type="${type}" style="display: none">
        <div class="popup-section">
            <div class="popup-group">
                ${!!title ? getBottomLayerHeaderTmpl(title, sub) : ''}
                <div class="popup-content">
                    <div class="popup-inner">
                        ${(plusboxButton === 'etc-plusbox') ? getBottomLayerButtonPlusbox(plusboxButtonText) : ''} <!-- CHPFMTASK-2128 플러스박스 만들기 2025-04-07 -->
                        <div class="select-container">
                        <ul class="select-list">
                        </ul>
                        </div>
                        ${(addButton === 'etc-account') ? getBottomLayerButtonEtc(addButtonText) : ''} 
                    </div>
                </div>
                ${(type === 'select-phone') ? getBottomLayerPhoneTmpl() : ''}
            </div>
        </div>
    </div>
`;

export const getBottomDateLayerTmpl = (type, title) => `
  <div class="popup-dialog ui-popup ui-bottom" data-type="${type}" style="display: none">
    <div class="popup-container">
      ${!!title ? getBottomLayerHeaderTmpl(title) : ''}
      <div class="popup-content">
        <div class="inner">
          <div class="ui-datepicker"></div>
        </div>
      </div>
      <div class="popup-footer">
        <div class="btns-area flex">
          <button type="button" class="btn-lv03 pink btn-item">
            <span class="txt">확인</span>
          </button>
        </div>
      </div>
      <button class="ico-area-tp02 btn-close-popup" type="button">
        <span class="hide-txt">팝업 닫기</span>
        <i class="ico-style close" aria-hidden="true"></i>
      </button>
    </div>
  </div>
`;

export const getBottomCalendarLayerTmpl = (type, title, sub) => `
  <div class="popup-dialog ui-popup ui-bottom" data-type="${type}" style="display: none">
    <div class="popup-section">
      <div class="popup-group">
        ${!!title ? getBottomLayerHeaderTmpl(title ,sub) : ''}
        <div class="popup-content">
            <div class="ui-datepicker"></div>
        </div>
      </div>
    </div>
  </div>
`;

export const getBottomLayerHeaderTmpl = (msg = '', sub = '') => `
    <div class="popup-header">
        <div class="title-group">
            <div class="title-field-popup">${msg}</div>
            ${(sub !== '') ? `<p class="txt-guide-popup">${sub}</p>` : ''}
        </div>
    </div>
`;

// select : 통신사 선택 타입   //CHPFMTASK-1573 "휴대폰이라면?" 추가
export const getBottomLayerPhoneTmpl = () => `
    <div class="popup-footer">
        <p class="txt-phone">타인명의 휴대폰이라면?</p>
        <a class="btn-under-link" href="#none">
            <span class="txt-link">공동인증서로 인증하기</span>
        </a>
    </div>
`;

// select button : 다른 은행계좌 추가      // FETASK-1382 : 셀렉트 팝업 하단 버튼 필요할때 .custom-ui 클래스태그에  data-add-button="" 값  버튼 타이틀 추가 add-button-text="" 값
export const getBottomLayerButtonEtc = (addButtonText) => `
<div class="add-btn-group">
  <button class="btn-option" type="button">
    <span class="area-option">
      <span class="r-box">
        <i class="ico-plus" aria-hidden="true"></i>
      </span>
      <span class="one-val">
        <span class="tit-option">${addButtonText == undefined ? '다른 은행계좌 추가' : addButtonText}</span>
      </span>
    </span>
  </button>
</div>
`;

// select button : 플러스박스 만들기 추가      // CHPFMTASK-2128 : 셀렉트 팝업 하단 버튼 필요할때 .custom-ui 클래스태그에  data-plusbox-button="" 값  버튼 타이틀 추가 plusbox-button-text="" 값
export const getBottomLayerButtonPlusbox = (plusboxButtonText) => `
<div class="add-btn-group">
  <button class="btn-option" type="button">
    <span class="area-option area-option line-bt">
      <span class="r-box">
        <i class="ico-plus" aria-hidden="true"></i>
      </span>
      <span class="one-val">
        <span class="tit-option">${plusboxButtonText == undefined ? '플러스박스 만들기' : plusboxButtonText}</span>
      </span>
    </span>
  </button>
</div>
`;

// select : 계좌선택 타입1
export const getBottomLayerBankListTmpl = (value = '', selected = '', disabled = '', text = '' , value01 = '',  value02 = '', tag = '', tagclass = '') => `
  <li class="select-item">
    <button class="btn-option ${selected}" type="button" data-val="${value}" ${disabled}>
        <span class="area-option">
            <span class="tit-option">${text}${(value02 !== '') ? ` : ${value02}` : ''} ${tag ?  `<span class="tag ${tagclass}"><span class="txt">${tag}</span></span>` : ''}</span>
            ${value01 ?  `<span class="txt-option">${value01}</span>` : ''}
        </span>
    </button>
  </li>
`;

// select : 계좌선택 타입2
export const getBottomLayerBankList2Tmpl = (value = '', selected = '', disabled = '', text = '' , value01 = '',  value02 = '',tag = '', tagclass = '') => `
  <li class="select-item">
    <button class="btn-option ${selected}" type="button" data-val="${value}" ${disabled}>
        <span class="area-option${value02 === '' ?` one-val` : ''}">
            <span class="tit-option">${text}${value01 ?  `(${value01})` : ''} ${tag ?  `<span class="tag ${tagclass}"><span class="txt">${tag}</span></span>` : ''}</span>
            ${(value02 !== '') ? `<span class="txt-option">${value02}</span>` : ''}
        </span>
    </button>
  </li>
`;

// select : 오픈뱅킹 타입
export const getBottomLayerOpenBankListTmpl = (value = '', selected = '', disabled = '', text = '' , value01 = '',  value02 = '', bank = '', img = '',tag = '', tagclass = '', is_opbk_acnt='') => `
  <li class="select-item">
    <button class="btn-option ${selected}" type="button" data-val="${value}" ${disabled}>
        <span class="area-option">
          ${(img !== '') ? `<i class="ico-bank w34 ${img}" ${is_opbk_acnt == 'true' ? 'aria-hidden="true"' : `role="img" aria-lable="${text}"`}></i>` : ''}
            <span>
                <span class="tit-option">${text} ${tag ?  `<span class="tag ${tagclass}"><span class="txt">${tag}</span></span>` : ''}</span>
                <span class="txt-option">${bank} ${value01}</span>
            </span>
        </span>
    </button>
  </li>
`;
export const getBottomLayerOpenBankList2Tmpl = (value = '', selected = '', disabled = '', text = '' , value01 = '',  value02 = '', bank = '', img = '',tag = '', tagclass = '', is_opbk_acnt='') => `
<li class="select-item">
  ${
    `<button class="btn-option ${selected}" type="button" data-val="${value}" ${disabled}>
      <span class="area-option">
        ${(img !== '') ? `<i class="ico-bank w34 ${img}"  ${is_opbk_acnt == 'true' ? 'aria-hidden="true"' : `role="img" aria-lable="${text}"`}></i>` : ''}
        <span${value02 === '' ?` class="one-val"` : ''}>
            <span class="tit-option">${text}${value01 ?  `(${value01})` : ''}  ${tag ?  `<span class="tag ${tagclass}"><span class="txt">${tag}</span></span>` : ''}</span>
            ${(value02.toUpperCase() === 'U' || value02.toUpperCase() === 'N') ? (
            `<span class="txt-option">&nbsp;</span>`
            ):(
              `<span class="txt-option">${(value02.toUpperCase() === 'L' || value02.toUpperCase() === 'X' || value02.toUpperCase() === 'T') ? `${accountErrorTmlp(value02)}` : (value02 !== '') ?` ${value02}` : ''}</span>`
            )}
        </span>
      </span>
    </button>
    ${(value02.toUpperCase() === 'U' || value02.toUpperCase() === 'N') ? (
    `${accountErrorTmlp(value02)}`
    ) : ''}
    `
  }
  </li>
`;

// select : 은행/증권사 타입
export const getBottomLayerBankFirmListTmpl = (content = '', group="") => `
  <li class="select-item ${group}">${content}</li>
`;

export const getBottomLayerBankFirmItemTmpl = (value = '', text = '', img = '', selected = '') => `
    <button class="btn-option ${selected}" type="button" data-val="${value}">
        <span class="area-option">
            <i class="${img} w44" aria-hidden="true"></i>
            <span class="tit-option">${text}</span>
        </span>
    </button>
`;

const accountErrorTmlp = (err) => {
  let errText; //N: 조회실패  U: 오픈뱅킹망 점검중, T: 해지계좌, L: 조회중, X: 조회실패(재조회불가)

  switch( err ) {
    case 'L' :
        errText = '조회중';
        break;
    case 'U' :
        errText = '오픈뱅킹망 점검중';
        break;
    case 'T' :
        errText = '해지계좌';
        break;
    case 'N' :
        errText = '조회실패';
        break;
    case 'X' :
        errText = '조회실패';
        break;
  }
  
  if (err === 'T' || err === 'X') {
    return `<i class="ico-warning" aria-hidden="true"></i> ${errText}`
  } else if (err === 'L') {
    return `<div class="sum-loading"><div class="dot-flashing" aria-hidden="true"><span class="hide-txt">${errText}</span></div></div>`
  } else {
    return `<button class="txt-lv03 ui-btn-animate btn-float" type="button">${errText} <i class="ico-refresh" aria-hidden="true"></i></button>`
  }
}


//dropdown layer template
export const getDropDownTmpl = () => `
  <div class="wrap-list-dropdown">
    <ul>
    </ul>
  </div>
`;

export const getDropDownListTmpl = (value = 'value', text = 'item') => `
  <li>
    <button type="button" data-val="${value}">${text} 111</span>
  </li>
`;





// alert layer template 기본 타입
// CHPFMTASK-1260 : legacyText 추가
export const getAlertLayerTmpl = (message = '', subMessage = '', legacyText = '', errorCode = '', banner = '', icoImg='', btnCancel = '', btnConfirm = '') => `
  <div class="popup-dialog ui-popup ui-alert" style="display:flex">
    <div class="popup-section">
        <div class="popup-group">
        <div class="popup-content">
            <div class="popup-inner">
                ${!!banner ? getAlertLayerBannerTmpl(banner) : ''}
                ${!!icoImg ? getAlertLayericoImgTmpl(icoImg) : ''}
                <p class="txt-alert">${message}</p>
                ${!!subMessage ? `<em class="txt-sub">${subMessage}</em>` : ''}
                ${!!legacyText ? `<div class="alert-legacy-html">${legacyText}</div>` : ''}
                ${!!errorCode ? getAlertLayerErrorCodeTmpl(errorCode.error, errorCode.guid) : ''}

            </div>
        </div>
        <div class="popup-footer">
            <div class="component-btn">
            <div class="btn-group">
                ${btnCancel}
                ${btnConfirm}
            </div>
            </div>
        </div>
        </div>
    </div>
    </div>
`;

export const getAlertLayerBannerTmpl = (banner) => `
    <div class="banner-alert">
        ${
            (!!banner.href)
            ?(
                `<a href="${banner.href}"><img src="${banner.src}" alt="${banner.alt}"></a>`
            ):(
                `<img src="${banner.src}" alt="${banner.alt}">`
            )
        }
    </div>
`;
// 240903 :  CHPFMTASK-1260  알럿 이미지태그 속성 추가 
export const getAlertLayericoImgTmpl = (icoImg) => `
      ${icoImg.src == undefined ? `<div class="alert-ico-figure">
      <i class="${icoImg.class}" aria-hidden="true"></i>
    </div>` : `<div class="alert-img-figure"><img class="${icoImg.class}" src="${icoImg.src}" alt="${icoImg.alt}" /></div>`}
    
`;

export const getAlertLayerErrorCodeTmpl = (error = '', guid = '') => `
  <div class="folding-wrap ui-expand">
    <button class="btn-arrow ui-expand-btn" type="button">
        <span class="txt-detail">자세히 보기</span>
        <i class="ico-arrow-open" aria-hidden="true"></i>
    </button>
    <div class="folding-box ui-expand-cont">
        ${!!error ? `<p class="txt-code">코드 : <span>${error}</span></p>` : ''}
        ${!!guid ? `<p class="txt-code">GUID : <span>${guid}</span></p>` : ''}
    </div>
  </div>
`;

export const getAlertLayerBtnCancelTmpl = (text = '아니요') => `
  <button class="btn-lv01 divider-gray ui-cancel" type="button">
    <span class="txt">${text}</span>
  </button>
`;

export const getAlertLayerBtnConfirmTmpl = (text = '네', size) => `
  <button class="btn-lv01 primary1 ui-confirm ${size != undefined ? `flex${size}` : ''}" type="button">
    <span class="txt">${text}</span>
  </button>
`;


//input close btn template
export const getInputButtonClose = () => `
    <button class="btn-delete-txt" type="button">
        <span class="hide-txt">입력 내용 삭제</span>
        <i class="ico-delete-input" aria-hidden="true"></i>
    </button>
`;

//select close btn template
export const getSelectButtonClose = () => `
    <button class="btn-delete-select" type="button">
        <span class="hide-txt">입력 내용 삭제</span>
        <i class="ico-delete-input" aria-hidden="true"></i>
    </button>
`;

//toast popup | opt.addClassName == 'withdraw-type' ? -> ${opt.addClassName.includes('withdraw-type') ?   240717 수정
export const getToastTmpl = (opt) => `
    <div class="toast-wrap ${opt.addClassName == undefined ? '' : opt.addClassName} ${opt.icon != undefined ? 'icon-type' : ''} ${opt.buttonText != undefined ? 'btn-type' : ''}" toast-idx=${opt.idx} style="display: none">
    ${opt.addClassName != undefined  ?
        `${opt.addClassName.includes('withdraw-type') ? 
          `
          <div class="toast-group">
            <a class="toast-txt-wrap" href="#">
              ${opt.wdIcon == undefined ? `` : `<i class="${opt.wdIcon} w36" aria-hidden="true" data-bankname="${opt.wdAcName}"></i>`}
              <div class="toast-column-box">
                  <div class="column-item">
                      <span>${opt.wdIcon == undefined ? '복사한 계좌' : `${opt.wdAcName}`}</span>
                      <span>${opt.wdAcNum}</span>  
                  </div>
                  <div class="column-item">
                    ${
                      (typeof opt.wdAcMoney == 'string' && opt.wdAcMoney.match('원')) ? `<span>${opt.wdAcMoney}</span>` :
                      opt.wdAcMoney == undefined ? '' : `<span>${opt.wdAcMoney}원</span>`
                    }
                      <span>이체하기</span>
                  </div>
              </div>
            </a>
            <button type="button" class="toast-close-btn" data-focus-e title="팝업 닫기">
                <i class="ico-close-popup" aria-hidden="true"></i>
            </button>
          </div>
          ` :
          `
          <div class="toast-group">
            ${opt.icon != undefined ? `<i class="${opt.icon == 'positive' ? 'ico-positive' : 'ico-negative'}"></i>` : ''}
            <p class="toast-txt">${opt.msg == undefined ? '' : opt.msg}</p>
            ${opt.buttonText != undefined ? `<button type="button" class="toast-btn"><span class="txt">${opt.buttonText}</span></button>` : ''}
          </div>
          `
        }`
        :
        `
        <div class="toast-group">
          ${opt.icon != undefined ? `<i class="${opt.icon == 'positive' ? 'ico-positive' : 'ico-negative'}"></i>` : ''}
          <p class="toast-txt">${opt.msg == undefined ? '' : opt.msg}</p>
          ${opt.buttonText != undefined ? `<button type="button" class="toast-btn"><span class="txt">${opt.buttonText}</span></button>` : ''}
        </div>
        `
      }
    </div>
`;

`
<div class="toast-wrap withdraw-type" style="display: none;">
            <div class="toast-group">
                <a class="toast-txt-wrap" href="#">
                    <i class="logo-bank090 w36" aria-hidden="true" data-bankname="카카오뱅크"></i>
                    <div class="toast-column-box">
                        <div class="column-item">
                            <span>카카오뱅크</span>
                            <span>12345678910</span>  
                        </div>
                        <div class="column-item">
                            <span>100,000원</span>
                            <span>이체하기</span>
                        </div>
                    </div>
                </a>
                <button type="button" class="toast-close-btn" title="팝업 닫기">
                    <i class="ico-close-popup" aria-hidden="true"></i>
                </button>
            </div>
        </div>`

// select close btn template
export const getCardToastTmpl = () => `
  <div class="tooltip-area align-bottom align-center">
    <div class="tooltip-box">
      <div class="tooltip-content">
        <p class="txt">카드를 옆으로 넘겨보세요</p>
      </div>
    </div>
  </div>
`;

//select 탭구조 | CHPFMTASK-1445 : 241016 
export function getBottomTab (tab, tabName){
let tabs = tab.split(',');
let tabLen = tabs.length;
let html = '';

html += `<div class="tab-content-group select-tab-group" tab-content-id="${tabName}">`
for (let i = 0; i < tabLen; i++) {
      html += `
      <div class="tab-content ui-tab-content" ${i == 0 ? 'style="display:block"': 'style="display:none"'}}>
        <ul class="select-list"></ul>
      </div>
    `
   
}
html += `</div>`
  // for (i=0; i<tab; i++){

  // }
  return html
}

 
// CHPFMTASK-1574 툴팁 팝업 
export const getTooltipLayerTmpl = (title = '', subtitle = '', listHtml = '', btnCancel = '', btnConfirm = '') => `
  <div class="popup-dialog ui-popup ui-bottom ui-popup-tooltip" style="display:none">
    <div class="popup-section">
        <div class="popup-group">
        <div class="popup-header">
          <div class="title-group">
            <div class="title-field-popup">${!!title ? title : ''}</div>
          </div>
        </div>
        <div class="popup-content">
            <div class="popup-inner">
                ${listHtml}
            </div>
        </div>
        <div class="popup-footer">
            <div class="component-btn">
            <div class="btn-group">
                ${btnCancel}
                ${btnConfirm}
            </div>
            </div>
        </div>
        </div>
    </div>
    </div>
`;
export const getTooltipLayerBtnCancelTmpl = (text = '취소') => `
  <button class="btn-lv01 divider-gray ui-cancel" type="button">
    <span class="txt">${text}</span>
  </button>
`;

export const getTooltipLayerBtnConfirmTmpl = (text = '확인', size) => `
  <button class="btn-lv01 primary1 ui-confirm ${size != undefined ? `flex${size}` : ''}" type="button">
    <span class="txt">${text}</span>
  </button>
`;